


















import { Component, Vue } from 'vue-property-decorator';
import OrderTable from '@/components/OrderTable.vue';
import OrderFilters from '@/components/OrderFilters.vue';
import { router } from '@/router';
import PermissionsService from '../services/permissions.service';

@Component({
  components: {OrderFilters, OrderTable}
})
export default class OrdersView extends Vue {
  get expandedOrderUuid(): string {
    return this.$route.params['orderUuid'];
  }

  goToNewOrder() {
    router.push('/orders/new');
  }

  get canCreateOrders(): boolean {
    return PermissionsService.can('orders', 'create');
  }
}
